import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PopupMessageType, StorageDetails } from 'app/components/Storage/types';
import { fetchStorageEffect } from 'app/store/Storage/effects';
import { Link } from 'types/api.types';
import { LoadingState } from 'types/enums';
import { StorageChangedPayload } from 'types/websocket.types';
import { SetShowUpgradePopupPayload } from './slice.types';

export interface StorageState {
  showUpgradePopup?: PopupMessageType;
  disableOverlay?: boolean;
  storage?: StorageDetails;
  storageLoadingState: LoadingState;
  _links?: {
    self?: Link;
  };
}

export const storageInitialState: StorageState = {
  storageLoadingState: LoadingState.PRISTINE,
};

const slice = createSlice({
  name: 'storage',
  initialState: storageInitialState,
  reducers: {
    updateStorageData(
      state,
      { payload }: PayloadAction<StorageChangedPayload>
    ) {
      const { payloadType, status, userGuid, ...rest } = payload;

      if (state.storage) {
        state.storage = {
          ...state.storage,
          ...rest,
        };
      }
    },
    setShowUpgradePopup(
      state,
      { payload }: PayloadAction<SetShowUpgradePopupPayload | undefined>
    ) {
      if (!payload) {
        state.showUpgradePopup = undefined;
        state.disableOverlay = undefined;
        return;
      }
      state.showUpgradePopup = payload.messageType;
      state.disableOverlay = payload.disableOverlay;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchStorageEffect.pending, (state) => {
        state.storageLoadingState = LoadingState.FETCHING;
      })
      .addCase(fetchStorageEffect.rejected, (state) => {
        state.storageLoadingState = LoadingState.ERROR;
      })
      .addCase(
        fetchStorageEffect.fulfilled,
        (state, { payload: { item, _links } }) => {
          state.storageLoadingState = LoadingState.FETCHED;
          state.storage = item;
          state._links = _links;
        }
      );
  },
});

export const { updateStorageData, setShowUpgradePopup } = slice.actions;

export const storageReducer = slice.reducer;
